import { useState, useEffect } from 'react';

import { useMainMachine } from '../../../utils/useMainMachine';
import { TextArea } from '../basic-ui/TextArea';
import { ACTIONS } from '../../../state/actions';
import { isStringHTML } from '../../../utils/html';
import { createDraftEchoes } from '../../../utils/draftEchoes';

function splitTags(str) {
  const i = str.indexOf('</');
  if (i === -1) return str;
  return [str.slice(0, i), str.slice(i)];
}

export function HtmlContent() {
  const { useSelector, machine } = useMainMachine();
  const selectedElement = useSelector(({ context }) => context.selectedElement);

  // for input elements we can edit the placeholder text instead
  const isInput = selectedElement.tagName === 'INPUT';

  const [value, setValue] = useState(isInput ? selectedElement.placeholder.trim() : selectedElement.innerHTML.trim());

  const isHTML = isInput ? false : isStringHTML(selectedElement.innerHTML);

  // we use innerHTML to display, but we need to send the full HTML to the API
  const wrapperTag = splitTags(selectedElement.html.replace(/^\s*(<[^>]*>)*.*?(\s*<\/[^>]*>)*\s*$/s, `$1$2`));

  // a late echo of an earlier keystroke must not overwrite newer typing
  const [echoes] = useState(createDraftEchoes);

  useEffect(() => {
    const incoming = isInput ? selectedElement.placeholder : selectedElement.innerHTML;
    if (!echoes.isEcho(incoming)) {
      setValue(incoming);
    }
  }, [echoes, isInput, selectedElement.placeholder, selectedElement.innerHTML]);

  return (
    <TextArea
      value={value}
      label="Content"
      onChange={(e) => {
        const v = e.target.value;
        setValue(v);
        echoes.sent(v);
        if (isInput) {
          machine.send({
            type: ACTIONS.SET_SELECTED_EL_ATTRIBUTE,
            attribute: 'placeholder',
            value: v,
          });
        } else {
          if (isHTML) {
            machine.send({
              type: ACTIONS.SET_SELECTED_EL_HTML,
              html: wrapperTag[0] + v + wrapperTag[1],
            });
          } else {
            machine.send({
              type: ACTIONS.SET_SELECTED_EL_TEXT,
              text: v,
              content_area: true,
            });
          }
        }
      }}
      labelClassName="!font-normal !text-gray-200"
    />
  );
}
